import React, { Component } from 'react';
import { Button, Label } from 'semantic-ui-react'
import { Grid, Divider, Header } from 'semantic-ui-react';
import styles from './uploadSTL.module.css'
import { Route } from 'react-router-dom'
import { Icon, Progress } from 'semantic-ui-react'
import AWS from 'aws-sdk';

class FilesUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            InfoHeader: "Usage Instructions: ",
            description1: "# Select one or multiple IPT files using the 'Select Files' button below.",
            description2: "# Click 'Start Upload' button",
            content: "Select files",
            files: null,
            isButtonDisabled: true,
            uploadStarted: false,
            uploadingFileNumber: 0,
            success: false,
            progress: 0,
            active: true,
            error: false
        };

        AWS.config.update({
            region: 'us-west-2',
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: 'us-west-2:9c66f931-8c9f-4425-b76f-59fc0d5fd2fb'
            })
        });

        this.bucketName = 'cctech-ml-work';
        this.s3 = new AWS.S3({
            apiVersion: '2006-03-01',
            params: { Bucket: this.bucketName }
        });
    }

    onChangeFile() {
        const fileInpt = document.getElementById('upload');
        // console.log("files : ", fileInpt.files)
        this.setState({
            files: fileInpt.files,
            isButtonDisabled: false
        })
    }

    uploadFileWithId(fileId) {
        // console.log('inside upload file')
        this.setState({
            uploadingFileNumber: fileId+1,
            success: false,
            progress: 0,
            active: true,
            error: false
        }, () => {
            let file = this.state.files[fileId]
            var fileKey = 'ml-mesh-segmentation/cad-upload/' + file.name;
            // console.log("fileKey : ", fileKey)

            this.s3.upload({
                Key: fileKey,
                Body: file,
                ACL: 'public-read'
            }).on('httpUploadProgress', (evt) => {
                // console.log('Progress:', (evt.loaded / evt.total) * 100);
                this.setState({
                    progress: Math.ceil((evt.loaded / evt.total) * 100)
                })
            }).send((err, data) => {
                if (err) {
                    // console.log('There was an error uploading your file: ', err.message);
                    this.setState({
                        active: false,
                        error: true,
                    })
                }

                this.setState({
                    progress: 100,
                    success: true,
                    active: false,
                    error: false,
                })
                // console.log('Successfully uploaded file.', fileId, this.state.files.length);
                if (this.state.files.length > (fileId + 1)) {
                    this.uploadFileWithId(fileId + 1)
                }
            });
        })
    }

    handleClick() {
        this.setState({
            uploadStarted: true
        }, () => {
            this.uploadFileWithId(0)
        })

    }

    render() {

        let uploadStatusComp = null
        if (this.state.uploadStarted) {
            if (!this.state.error) {
                uploadStatusComp = 
                <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                    <div className={"ui small header font-weight-bold"}>
                        File Upload [S3]
                    </div>                   
                    <Progress percent={this.state.progress} color='blue'
                        active={this.state.active} progress>{this.state.success ?
                        "All Done" : "Uploading file " + this.state.uploadingFileNumber + "/" + this.state.files.length}</Progress>
                </div>
            }
            else {
                uploadStatusComp = 
                <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
                    <div className={"ui small header font-weight-bold"}>
                        File Upload [S3]
                    </div> 
                    <Progress percent={100} error>Something went wrong(</Progress>
                </div>
            }
        }

        return (
            <Grid columns={3} padded='vertically' className={styles['gridStyle']}>
                <Grid.Column stretched={true}>
                </Grid.Column>
                <Grid.Column textAlign='center' >
                    <Grid.Row>
                        <Grid.Row className={styles['rowStyle1 ']}>
                            <Header as='h1'>{this.state.InfoHeader}</Header>
                        </Grid.Row>
                        <Divider inverted section />
                        <Grid.Row centered={false} className={styles['rowStyle1']}>
                            <b>{this.state.description1}</b><br /><br />
                            <b>{this.state.description2}</b>
                        </Grid.Row>
                    </Grid.Row>
                    <Divider inverted section />
                    <Grid.Row>
                        <Label as="label" basic htmlFor="upload">
                            <Button icon="upload" id="btnUpload" label={{ basic: true, content: this.state.content }} labelPosition="right" />
                            <input hidden id="upload" multiple="multiple" type="file" onChange={this.onChangeFile.bind(this)} accept=".ipt" />
                        </Label>
                        <Route render={({ history }) => (
                            <Button primary onClick={() => {
                                // this.props.handleSegmentation(this.state.file, history)
                                this.handleClick()
                            }} disabled={this.state.isButtonDisabled} >Start Upload</Button>
                        )} />
                    </Grid.Row>
                    <Divider inverted section />

                    <Grid.Row>
                        {uploadStatusComp}
                    </Grid.Row>
                </Grid.Column>
            </Grid>
        );
    }
}

export default FilesUpload;